import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.overlay.confirmation.Component,
    content.admin.modals.agentAssignment.Component,
  ],
  selector: 'atn-admin-tenant-page-agents-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  public readonly agentAssignmentsEc = ngCore.inject(
    state.admin.agentAssignments.Collection,
  )

  /** @see {@link state.admin.agentAssignment.Feature} */
  public agentAssignmentFeature = ngCore.inject(
    state.admin.agentAssignment.Feature,
  )

  /** Canonical table input for agents assigned to this tenant. */
  public readonly agentAssignmentsTableConfig = {
    collection: this.agentAssignmentsEc,
    view: {
      creation: () => this.addClickHandlerCallback(),
      search: true,
      title: 'Agent Assignments',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.agentAssignments.TypeParams>

  /**
   * Handles the click event on the table's add button.
   */
  public addClickHandlerCallback = () => {
    this.agentAssignmentFeature.actions.setEditingMode
      .from('Admin.Tenant.Agents.Tab.Table.Add.Clicked')
      .dispatch({ isEditing: true })
  }

  /**
   * Discard changes for unassigning user
   */
  public cancelUnassignmentClickHandler(): void {
    this.agentAssignmentFeature.actions.markUserForUnassignment
      .from(
        'Admin.Tenant.Agents.Tab.Confirmation.Overlay.Cancel.Button.Clicked',
      )
      .dispatch({ user: undefined })
  }

  /**
   * Confirm user unassignment
   */
  public confirmUnassignmentClickHandler(): void {
    const deletingAssignment =
      this.agentAssignmentFeature.selectors.deletingAssignment.asSignal()
    if (deletingAssignment) {
      this.agentAssignmentFeature.actions.assignAgentAccess
        .from(
          'Admin.Tenant.Agents.Tab.Confirmation.Overlay.Confirm.Button.Clicked',
        )
        .dispatch({ assignments: [deletingAssignment] })
    }
  }
}
